import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-commerce',
  templateUrl: './commerce.component.html',
  styleUrls: ['./commerce.component.scss']
})
export class CommerceComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
